// Angular imports
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

// Common imports
import { Utils } from 'cc-common';

// Service imports
import { UserService } from '../../_services/data-services/user.service';

// Model imports
import { ActionAccessListParameterDto } from '../../_models/action-access-list-parameter-dto';
import { ActionAccessResultDto } from '../../_models/action-access-result-dto';

@Component({
    selector: 'app-hyperlink-creator',
    templateUrl: './hyperlink-creator.component.html',
    styleUrls: ['./hyperlink-creator.component.scss']
})
export class HyperlinkCreatorComponent implements OnInit {
    @Input() title: string;
    @Input() displayText: string;
    @Input() communityId: number;
    @Input() customerId: string;
    @Input() actionCode: string;
    @Input() cssClass = '';
    @Input() textLocation = 'left';
    /**
     * Mode options
     * 1. hyperlinkOnly
     * 2. textOnly
     * 3. null
     * 4. email
     */
    @Input() mode: string;

    @Output() onLinkClick = new EventEmitter<void>();

    isInternalUser: boolean;
    showHyperLink = false;
    isEmail = false;

    constructor(private readonly userService: UserService) {}

    ngOnInit() {
        if (Utils.isNullOrUndefined(this.title) && Utils.notNullAndDefined(this.displayText)) {
            this.title = this.displayText;
        }

        this.isInternalUser = this.userService.isInternal();
        if (Utils.isNullOrUndefined(this.mode)) {
            this.showHyperLink = Utils.isTrue(this.isInternalUser);

            setTimeout(() => {
                if (Utils.notNullAndDefined(this.actionCode)) {
                    this.checkActionAccess();
                }
            }, 200);
        } else {
            if (Utils.equalsIgnoreCase(this.mode, 'hyperlinkOnly')) {
                this.showHyperLink = true;
            } else if (Utils.equalsIgnoreCase(this.mode, 'email')) {
                if (Utils.isTrue(this.isInternalUser)) {
                    this.showHyperLink = true;
                } else {
                    this.showHyperLink = false;
                    this.isEmail = true;
                }
            }
        }
    }

    onHyperlinkClick(): void {
        this.onLinkClick.emit();
    }

    private checkActionAccess(): void {
        const params: ActionAccessListParameterDto = new ActionAccessListParameterDto();
        params.communityId = Utils.notNullAndDefined(this.communityId) ? this.communityId : null;
        params.customerId = Utils.notNullAndDefined(this.customerId) ? this.customerId : null;
        params.clearCache = false;

        this.userService.getActionList(params).subscribe((actions: ActionAccessResultDto[]) => {
            const actionIndex = actions.findIndex((r) => Utils.equalsIgnoreCase(r.code, this.actionCode));
            this.showHyperLink = Utils.notEquals(actionIndex, -1);
        });
    }
}
